var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useDispatch, useSelector } from "react-redux";
import React, { useCallback, useEffect } from "react";
import { premiumCalculatePost, premiumCalculatePostClearData, } from "../../../store/premiumCalculate/actions";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
var DAMAGE_BACKUP_BY_PLAN = {
    A: "150000",
    B: "300000",
    C: "600000",
};
export var usePremiumCalculate = function (setDisableNextButton) {
    var dispatch = useDispatch();
    var _a = React.useState(0), sumValues = _a[0], setSumValues = _a[1];
    var _b = React.useState("0"), damageBackup = _b[0], setDamageBackup = _b[1];
    var _c = React.useState("0"), insuredProperty = _c[0], setInsuredProperty = _c[1];
    var _d = React.useState(null), dataCalculate = _d[0], setDataCalculate = _d[1];
    var plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var _e = useSelector(function (state) { return ({
        loadingCalculate: state.PremiumCalculate.loadingCalculate,
        responseCalculate: state.PremiumCalculate.responseCalculate,
        errorCalculate: state.PremiumCalculate.errorCalculate,
    }); }), loadingCalculate = _e.loadingCalculate, responseCalculate = _e.responseCalculate, errorCalculate = _e.errorCalculate;
    var onCalculateRate = useCallback(function (data, params) {
        var totalInsuredValue = data.totalInsuredValue, restData = __rest(data, ["totalInsuredValue"]);
        var buildingValue = parseFloat(data.buildingValue) || 0;
        var merchandiseValue = parseFloat(data.merchandiseValue) || 0;
        var furnitureValue = parseFloat(data.furnitureValue) || 0;
        var totalInsured = parseFloat(data.totalInsuredValue) || 0;
        var totalSum = buildingValue + merchandiseValue + furnitureValue + totalInsured;
        setSumValues(totalSum);
        var body = {
            productCode: "SC/".concat(params.productCode),
            planCode: params.planCode,
            inputData: __assign(__assign({}, restData), { transitValue: totalInsuredValue }),
        };
        dispatch(premiumCalculatePost(body));
    }, [dispatch]);
    useEffect(function () {
        if (responseCalculate) {
            setInsuredProperty(sumValues.toString());
            setDataCalculate(responseCalculate);
            setDisableNextButton(false);
            var damageValue = (plan === null || plan === void 0 ? void 0 : plan.code)
                ? DAMAGE_BACKUP_BY_PLAN[plan.code] || "0"
                : "0";
            setDamageBackup(damageValue);
        }
        dispatch(premiumCalculatePostClearData());
    }, [responseCalculate]);
    return {
        loadingCalculate: loadingCalculate,
        errorCalculate: errorCalculate,
        dataCalculate: dataCalculate,
        onCalculateRate: onCalculateRate,
        damageBackup: damageBackup,
        insuredProperty: insuredProperty,
    };
};
